import axios from 'axios'
import Qs from 'qs'
import VueCookies from 'vue-cookies';
import Fingerprint2 from 'fingerprintjs2'
// import topNavigation from '@/components/top_navigation.vue'
import {
	Message
} from 'element-ui'
// const {set, get, isKey } = VueCookies
// const AUTH_TOKEN = 1
// console.log(process.env.VUE_APP_ENV)
var deviceId;
Fingerprint2.get((components)=> {
  const values = components.map((component,index)=> {
    if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
      return component.value.replace(/\bNetType\/\w+\b/, '')
    }
    return component.value
  })
  // 生成最终id murmur   
  deviceId = Fingerprint2.x64hash128(values.join(''), 31)
	localStorage.setItem('deviceId',deviceId)
	if(localStorage.getItem('deviceId') == ''){
		window.location.reload()
	}

})
// console.log(deviceId)

const axiosInstance = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, //'/api'   process.env.VUE_APP_BASE_API
	headers: {
		// 'Authorization': AUTH_TOKEN,
		'Content-Type': 'application/json',
		'accessToken': localStorage.getItem('accessToken'),
		'deviceId':localStorage.getItem('deviceId'),
	},
	transformRequest: [function(data, headers) {
		if (headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
			if (data instanceof(FormData || URLSearchParams)) return data;
			else return Qs.stringify(data);
		} else if (headers['Content-Type'].includes('application/json')) return JSON.stringify(data)
	}]
})
export default axiosInstance

axiosInstance.interceptors.request.use(function(config) {
	// 在发送请求之前做些什么
	if (VueCookies.isKey('Authorization')) {
		config.headers.Authorization = VueCookies.get('Authorization')
	}
	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
axiosInstance.interceptors.response.use(function(response) {
	// 2xx 范围内的状态码都会触发该函数。
	// 对响应数据做点什么
	// console.log(response)
	if (response.data.code != 200 && response.data.code != 0 && response.data.code != 600 && response.data.code!= 401) {
		return Message.error(response.data.msg)
		// console.log(topNavigation)
		// topNavigation.methods.login()
		// if(response.data.code != 401){
		// 	return Message.error(response.data.msg)
		// }else{
		// 	console.log(this.$route)
		// }
	} else {
		return response.data
	}
}, function(error) {
	// 超出 2xx 范围的状态码都会触发该函数。
	// 对响应错误做点什么
	return Promise.reject(error);
});
